import {RowParser} from './row-parser';

const concatenate = (buf1, buf2) => {
  const resBuffer = new ArrayBuffer(buf1.length + buf2.length);
  const res = new Uint8Array(resBuffer);
  res.set(buf1, 0);
  res.set(buf2, buf1.length);
  return res;
};

/**
 * @class
 * @classdesc The JsonStreamReader provides functionality for reading streamed JSON responses.
 */
export class JsonStreamReader {
  constructor(reader) {
    this.reader = reader;
    this.lines = [];
    this.rest = '';
    this.textDecoder = new TextDecoder('utf-8');
    this.rowParser = new RowParser();
  }

  /**
   * Read next from stream
   * @return  {Object} response
   */
  async next(concat = true) {
    if (this.lines.length === 0) {
      let line = new Uint8Array();
      let done = false;

      while (!done) {
        const res = await this.reader.read();
        if (res.value && concat) {
          line = concatenate(line, res.value);
        } else {
          line = res.value;
          done = true;
        }
        if (concat) {
          done = res.done;
        }
      }

      const text = this.textDecoder.decode(line);

      if (!text) {
        return null;
      }
      const {lines, rest} = this.rowParser.parse(this.rest + text);
      this.lines = lines;
      this.rest = rest;
    }

    if (this.lines.length === 0) {
      return null;
    }
    const line = this.lines.splice(0, 1)[0];
    return {value: JSON.parse(line)};
  }
}
